import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FaArrowLeftLong } from "react-icons/fa6";
import AsyncSelect from "react-select/async";

import FormInput from "../../../components/common/FormInput/FormInput";
import UploadImage from "../../../components/common/UploadImage/UplaodImage";
import Button from "../../../components/common/Button/Button";

import { addCategory, Menulist } from "../../../api/service/products.service";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";

const AddProductCategory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedMenu, setSelectedMenu] = useState(null);

  const [formData, setFormData] = useState({
    menu_id: "",
    title: "",
    sub_title: "",
    text: "",
    slug: "",
  });

  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedIcon, setSelectedIcon] = useState(null);


  // useEffect(() => {
  //   const slug = location.pathname
  //     .replace(/^\/+/, "")
  //     .replace(/\/+/g, "-")
  //     .toLowerCase();

  //   setFormData(prev => ({ ...prev, slug }));
  // }, [location.pathname]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (file) => setSelectedImage(file);
  const handleIconChange = (file) => setSelectedIcon(file);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) return showToast.error("Enter title");
    if (!formData.text.trim()) return showToast.error("Enter description");
    if (!formData.slug.trim()) return showToast.error("Enter description");
    if (!selectedImage) return showToast.error("Upload category image");
    if (!selectedIcon) return showToast.error("Upload category icon");

    try {
      setLoading(true);

      const fd = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          fd.append(key, value);
        }
      });
      fd.append("image", selectedImage);
      fd.append("icon", selectedIcon);

      const res = await addCategory(fd);
      showToast.success(res?.message || "Category added successfully");
      navigate(-1);
    } catch (error) {
      console.error(error);
      showToast.error("Failed to add category");
    } finally {
      setLoading(false);
    }
  };


  const loadMenuOptions = async (inputValue) => {
    try {

      const res = await Menulist({
        page: 1,
        limit: 10,
        search: inputValue || ""
      });

   

      const menus = res?.data || [];


      return menus.map(menu => ({
        value: menu.id,
        label: menu.name,
      }));
    } catch (error) {
      console.error("Error loading menus:", error);
      return [];
    }
  };

  return (
    <>
      <div className="d-flex align-items-center gap-2 mb-3">
        <FaArrowLeftLong
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer" }}
        />
        <h3 className="mb-0 management-tile ml-2">Category Management</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <Row>

     


          <Col xs={12} md={6} className="mb-3">
            <label className="form-label">
              Category Icon <span className="text-danger">*</span>
            </label>
            <UploadImage onFileSelect={handleIconChange} multiple={false} />
            {selectedIcon && (
              <small className="text-success">✓ {selectedIcon.name}</small>
            )}
          </Col>


          <Col xs={12} md={6} className="mb-3">
            <label className="form-label">
              Category Image <span className="text-danger">*</span>
            </label>
            <UploadImage onFileSelect={handleImageChange} multiple={false} />
            {selectedImage && (
              <small className="text-success">✓ {selectedImage.name}</small>
            )}
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">
              Category Title <span className="text-danger">*</span>
            </label>
            <FormInput
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter category title"
            />
          </Col>


          <Col lg={6} md={6} sm={12} className="mb-3">
            <label className="form-label">Category Subtitle</label>
            <FormInput
              name="sub_title"
              value={formData.sub_title}
              onChange={handleChange}
              placeholder="Optional subtitle"
            />
          </Col>
     <Col lg={6} md={6} sm={12} className="mb-3">
            <label className="form-label">Select Menu (Optional)</label>
            <AsyncSelect
              cacheOptions
              defaultOptions={true}
              loadOptions={loadMenuOptions}
              isClearable
              placeholder="Select Menu"
              value={selectedMenu}
              onChange={(option) => {
                setSelectedMenu(option);
                setFormData(prev => ({
                  ...prev,
                  menu_id: option ? option.value : "",
                }));
              }}
            />

          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">
              Category Description <span className="text-danger">*</span>
            </label>
            <FormInput
              type="textarea"
              name="text"
              value={formData.text}
              onChange={handleChange}
              placeholder="Enter description"
            />
          </Col>


          <Col xs={12} className="mb-3">
            <label className="form-label">Category Slug</label>
            <FormInput
              name="slug"
              value={formData.slug}
              onChange={handleChange}
              placeholder="Enter slug"
            />
          </Col>


          <Col xs={12}>
            <Button type="submit" disabled={loading}>
              {loading ? "Adding..." : "Add Category"}
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default AddProductCategory;
